module.exports = __webpack_public_path__ + "static/media/Artboard14.a6b76496.png";